(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.financial-statement
  (:require
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn financial-statements-section
  [{:keys [group-income-statement statement-of-financial-position
           cash-flow-statement]}
   props]
  [section
   "Financial statements"
   (str "financial-statements-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Consolidated statement of comprehensive income (IFRS), €"
     group-income-statement props]
    [tabular-card/dynamic-table "Consolidated statement of financial position (IFRS), €"
     statement-of-financial-position props]
    [tabular-card/dynamic-table "Consolidated statement of cash flows (IFRS), €" cash-flow-statement
     props]]])
